import { Component, Input, OnInit, EventEmitter, ViewEncapsulation } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { LoggingService } from '@services/logging.service';
import { FilterService } from '@services/filter.service';
import { NgModel } from '@angular/forms';
import { RegularExpressionPattern } from '@shared/_constants';
import * as Constants from '@shared/_constants';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FilterUtilService } from '../shared/filter-util.service';
import { ControlContainer, NgForm } from '@angular/forms';
import { StudySearchFilter } from '@models/studySearchFilter.model';
import { StudySearchStrategy } from '@models/searchStrategy.model';

@Component({
  selector: 'app-filter-subsidiary-characteristics',
  templateUrl: './filter-subsidiary-characteristics.component.html',
  styleUrls: ['./filter-subsidiary-characteristics.component.css'],
  encapsulation: ViewEncapsulation.None,
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class FilterSubsidiaryCharacteristicsComponent implements OnInit {
  public subsidiaryCharacteristics: TreeNode[];
  @Input() filter: any;

  formDirty = false;
  regularExpressionPattern: typeof RegularExpressionPattern = RegularExpressionPattern;
  rowData: EventEmitter<any> = new EventEmitter<any>();

  @Input() readOnly: boolean;
  strategy: StudySearchFilter;
  searchStrategy: StudySearchStrategy;

  private destroy$ = new Subject();

  constructor(private logger: LoggingService, private filterService: FilterService, private filterUtilService: FilterUtilService) {}
  ngOnInit() {
    this.loadInitialData();
  }

  loadInitialData() {
    this.logger.info(this.constructor.name, Constants.LoggerMessages.LOGGER_NGONINIT, Constants.LoggerMessages.LOGGER_START);
    this.filterUtilService.spinnerRS.next(true);

    this.filterService
      .getSubsidiaryCharacteristics$(this.readOnly)
      .pipe(takeUntil(this.destroy$))
      .subscribe((_subsidiaryCharacteristics) => {
        this.subsidiaryCharacteristics = _subsidiaryCharacteristics;
      });

    this.filterUtilService.spinnerRS.next(false);
  }

  ShowValidationMessage(item: NgModel): boolean {
    return (item.errors || false) && (!item.pristine || item.touched);
  }

  public sortSelection(selection: TreeNode[]): void {
    return this.filterUtilService.sortSelection(selection);
  }

  CheckEndGreaterThanBeginning(beginning: string, ending: string): boolean {
    return this.filterUtilService.checkEndGreaterThanBeginning(beginning, ending);
  }
}
